// icons
import { MdScience, MdOutlineSelectAll } from "react-icons/md";

const sandbox = {
  id: 'sandbox-group',
  type: 'group',
  roles: [1],
  breadcrumbs: false,
  children: [
    {
      id: 'sandbox',
      title: "Sandbox",
      type: 'collapse',
      icon: MdScience,
      children: [
        {
          id: 'wireframe',
          title: "Wireframe",
          type: 'item',
          breadcrumbs: false,
          icon: MdOutlineSelectAll,
          url: '/sandbox/wireframe'
        }
      ]
    }
  ]
};

export default sandbox;
